export default "__VITE_PUBLIC_ASSET__76c1aa57__"